import { ascend, descend, prop, sortWith } from 'ramda'

export const UNNAMED_AGENCY = 'Unnamed agency'

export type TAgencyNames = {
  agencyName?: string | null
  tradingAs?: string | null
}

export type TAgencyOption = {
  label: string
  companyName?: string
  role?: string
  value: string
  isCurrent: boolean
  searchText: string
}

const trimmed = (value?: string | null) => (value ?? '').trim()

export const getAgencyHeading = (agency: TAgencyNames, fallback: string = UNNAMED_AGENCY) =>
  trimmed(agency.tradingAs) || trimmed(agency.agencyName) || fallback

export const getAgencyCompanyName = (agency: TAgencyNames) => {
  const companyName = trimmed(agency.agencyName)

  return companyName && companyName !== getAgencyHeading(agency) ? companyName : undefined
}

export const toAgencyOption = (
  agency: TAgencyNames & { agencyId: string },
  { currentAgencyId, role }: { currentAgencyId?: string | null; role?: string } = {},
): TAgencyOption => {
  const label = getAgencyHeading(agency)
  const companyName = getAgencyCompanyName(agency)

  return {
    label,
    companyName,
    role,
    value: agency.agencyId,
    isCurrent: !!currentAgencyId && agency.agencyId === currentAgencyId,
    searchText: [label, companyName, role, agency.agencyId].filter(Boolean).join(' '),
  }
}

export const sortAgencyOptions = sortWith<TAgencyOption>([
  descend(prop('isCurrent')),
  ascend(option => option.label.toLowerCase()),
])

/** Matches on trading name, company name, role and agency id, ignoring case and padding */
export const filterAgencyOption = ({ data }: { data: TAgencyOption }, rawInput: string) =>
  data.searchText.toLowerCase().includes(rawInput.trim().toLowerCase())
